var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReportFail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 180,
    height: 180,
    viewBox: "0 0 180 180",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 90,
    r: 90,
    fill: "#F96850",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M87.048 81.054c-.33-6.807-.585-13.62-1.028-20.419-.169-2.6.713-3.389 3.329-3.499 9.849-.415 9.901-.514 9.602 9.527-.34 11.465-.983 22.925-1.098 34.391-.043 4.228-1.881 4.69-5.433 4.836-3.972.165-4.643-1.413-4.658-4.903-.03-6.643-.56-13.283-.881-19.925l.167-.008M100.204 121.108c-.01 3.851-3.575 7.27-7.433 7.129-3.719-.136-6.785-3.387-6.771-7.18.015-3.928 2.949-6.963 6.82-7.055 3.985-.094 7.394 3.188 7.384 7.106"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportFail);
export default __webpack_public_path__ + "static/media/report-fail.56adddaa2fe188653d20d58a207c6138.svg";
export { ForwardRef as ReactComponent };